var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-avatar',{attrs:{"src":_vm.getAvatar()}}),_c('br'),_c('span',{staticClass:"overNone"},[_vm._v(_vm._s(_vm.getName()))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }